
import {
  defineComponent,
  ref,
  onMounted,
} from 'vue';
import PageType from '@/classes/PageType';

export default defineComponent({
  props: {
    pageType: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const icon = ref<InstanceType<typeof HTMLElement>>();

    const {
      ioappConfig: {
        themeUri,
      },
    } = window;

    onMounted(() => {
      if (icon.value) {
        icon.value.style.backgroundImage = `url('${themeUri}/assets/img/page_type/${PageType.getById(props.pageType)}.svg')`;
      }
    });

    return {
      icon,
    };
  },
});
